// hooks/usePrivacyData.ts
import { useState, useMemo } from 'react';
import { LocalizedData, Avisos, FileRaw, File } from './types';

declare global {
  interface Window {
    VistaPrivaData?: LocalizedData[];
  }
}


function getFileTypeFromUrl(url: string): string {
  const ext = url.split('.').pop();
  return ext ? ext.toLowerCase() : 'pdf';
}

function buildDocumentsData(files: FileRaw[], site_url: string): Avisos[] {
  const groupedMap = new Map<string, Partial<Avisos>>();

  files.forEach((file) => {
    const isExpired =
      file.is_temporal == 1 && file.temporality && new Date(file.temporality) < new Date();
    if (isExpired) return;

    const label = file.process_name || file.process_id || 'Sin nombre';

    if (!groupedMap.has(label)) {
      groupedMap.set(label, {
        label,
        simplified: null,
        integral: null
      });
    }

    const entry = groupedMap.get(label)!;

    // Solo crear fileObj si tiene los datos necesarios
    if (file.type_name && file.url_file) {
      const fileObj: File = {
        type: getFileTypeFromUrl(file.url_file),
        name_file: file.notice_name || 'file.pdf',
        url: file.url_file.startsWith('http') ? file.url_file : site_url + file.url_file,
        actions: true
      };

      if (file.type_name.includes('Simplificado')) {
        entry.simplified = fileObj;
      } else if (file.type_name.includes('Integral')) {
        entry.integral = fileObj;
      }
    }
  });

  let idCounter = 1;
  return Array.from(groupedMap.values()).map((entry) => {
    return {
      id: idCounter++,
      label: entry.label!,
      simplified: entry.simplified || { type: 'placeholder' },
      integral: entry.integral || { type: 'placeholder' }
    };
  });
}
export const usePrivacyData = () => {
  const localizedData: LocalizedData | null = window.VistaPrivaData?.[0] ?? null;

  const documentsData = useMemo(() => {
      if (!localizedData || !localizedData?.data?.files) return [];
      const { files, site_url } = localizedData.data;
      return buildDocumentsData(files, site_url);
  }, [localizedData]);
  return {
      localizedData,
      documentsData,
      hasData: Boolean(localizedData && localizedData?.data),
      hasFiles: Boolean(localizedData && localizedData?.data?.files)
  };
};
